import React from 'react';

import withPageComponents from '../../page/components/with-page-components';
import SeoMeta from '../../page/components/seo-meta';

const mapSEOData = (finderResults, seo) => {
    const { vwaDetails } = finderResults || {};
    const { seoCanonical } = vwaDetails || {};
    return {
        ...seo,
        canonical: seoCanonical || seo.canonical,
    };
};

export default withPageComponents(
    ({ finderResults, seo, url }) => {
        return <SeoMeta seo={mapSEOData(finderResults, seo || {}, url)} />;
    },
    { components: ['finderResults'], seo: true }
);
